import axios from 'axios';
import queryString from 'query-string';

// import { getStoredAuthToken, removeStoredAuthToken } from 'shared/utils/authToken';

const defaults = {
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000',
  headers: () => ({
    'Content-Type': 'application/json',
    // Authorization: getStoredAuthToken() ? `Bearer ${getStoredAuthToken()}` : undefined,
  }),
  error: {
    code: 'INTERNAL_ERROR',
    message: 'Something went wrong. Please check your internet connection or contact our support.',
    status: 503,
    data: {},
  },
};

const objectToQueryString = (obj, options = {}) => 
  queryString.stringify(obj, {
    arrayFormat: 'bracket',
    ...options,
  });


const apiRequest = (method, url, variables) =>
  new Promise((resolve, reject) => {
    console.log("API call: " + url + ", vars=" + JSON.stringify(variables))
    axios({
      url: `${defaults.baseURL}${url}`,
      method,
      headers: defaults.headers(),
      params: method === 'get' ? variables : undefined,
      data: method !== 'get' ? variables : undefined,
      paramsSerializer: objectToQueryString,
    }).then(
      response => {
        resolve(response.data);
      },
      error => {
        if (error.response) {
          // if (error.response.data.error.code === 'INVALID_TOKEN') {
            // removeStoredAuthToken();
            // history.push('/authenticate');
          // } else {
            reject(error.response.data.error);
          // }
        } else {
          reject(defaults.error);
        }
      },
    );
  });

export const optimisticUpdate = async (url, { updatedFields, currentFields, setLocalData }) => {
  try {
    setLocalData(updatedFields);
    await apiRequest('put', url, updatedFields);
  } catch (error) {
    setLocalData(currentFields);
    // toast.error(error);
  }
};

export default {
  get: (...args) => apiRequest('get', ...args),
  post: (...args) => apiRequest('post', ...args),
  put: (...args) => apiRequest('put', ...args),
  patch: (...args) => apiRequest('patch', ...args),
  delete: (...args) => apiRequest('delete', ...args),
  apiRequest,
  optimisticUpdate,
};
